// (function(a,b,c){if(c in b&&b[c]){var d,e=a.location,f=/^(a|html)$/i;a.addEventListener("click",function(a){d=a.target;while(!f.test(d.nodeName))d=d.parentNode;"href"in d&&(d.href.indexOf("http")||~d.href.indexOf(e.host))&&(a.preventDefault(),e.href=d.href)},!1)}})(document,window.navigator,"standalone")
document.addEventListener('DOMContentLoaded', function () {
  
  document.querySelectorAll('.forgot-pw').forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      var loginComponent = this.closest('.login-component');

      if (loginComponent) {
        loginComponent.querySelectorAll('.show__hide').forEach(function (el) {
          el.style.display = 'none';
        });
      }
      

      var target = this.getAttribute('href');
      if (target) {
        var targetElement = loginComponent.querySelector(target);
        if (targetElement) {
          targetElement.style.display = 'block';
        }
      }
    });
  });

  var link = document.querySelector('a[aria-controls="AddAddress"]');
  if(link){
    link.addEventListener('click', function(event) {
      event.preventDefault(); 
      
      var addAddressDiv = document.getElementById('AddAddress');
      
      if (addAddressDiv.style.display === 'block') {
        addAddressDiv.style.display = 'none';
      } else {
        addAddressDiv.style.display = 'block';
      }
    });
  }
});

 
// show msgs
  function showMessage(type, iconClass, message) {
    var messageWrap = document.getElementById('messageWrap');
    var messageContent = document.getElementById('messageContent');
    var messageIcon = document.getElementById('messageIcon');
    var messageIconi = document.getElementById('messageIcon').firstElementChild;
    var messageText = document.getElementById('messageText');
  
    // Set the type (success or error)
    messageContent.className = 'message ' + type;
    messageIcon.classList.add(type);
    messageIconi.className = 'fa ' + iconClass;
    messageText.textContent = message;
  
    // Add 'active' class to display the message
    messageWrap.classList.add('active');

    setTimeout(function() {
      messageWrap.classList.remove('active');
    }, 2000);
  }
  
// Slide cart functionality
function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

// Update cart item count across the page
function updateCartItemCounts(count) {
  document.querySelectorAll(".items").forEach((el) => {
    el.textContent = count;
  });
}

// Ensure progress visibility after the first item is added
function toggleProgressVisibility(totalItems) {
  const progressContainer = document.querySelector('.discount-progress');
  progressContainer.style.display = totalItems > 0 ? 'block' : 'none';
}

// Function to fetch and update the cart drawer content
async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer&ts=" + Date.now(), { cache: "no-store" });
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;
  updateProgressBar();
  addCartDrawerListeners();
}

// Attach event listeners to the cart drawer elements (e.g., buttons)
function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        document.querySelector(".spinner").style.display = "flex";
        const rootItem = button.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");
        const currentQuantity = Number(button.parentElement.querySelector("input").value);
        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        if (newQuantity < 0) return;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
        document.querySelector(".spinner").style.display = 'none';
      });
    });

  // delete functionality
  document
    .querySelectorAll(".remove-btn")
    .forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const rootItem = button.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");
        document.querySelector(".spinner").style.display = 'flex';
        // Remove the item by setting its quantity to 0
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
        document.querySelector(".spinner").style.display = 'none';
      });
    });

  // Prevent closing the cart drawer when clicking inside the drawer
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // Close the cart drawer on outside clicks
  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

// Update the cart after adding a product (main-product page)
document
  .querySelectorAll('form[action="/cart/add"], form[data-add-to-cart-form]')
  .forEach((form) => {
    // Skip the giftbox product form (it has its own handler)
    if (form.dataset.giftboxForm === "true") return;

    if (form.dataset.ajaxAddInit === "1") return;
    form.dataset.ajaxAddInit = "1";

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // --- 1) ADD TO CART (this is the only part that should show an error toast) ---
      let data;
      try {
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" },
          cache: "no-store",
        });

        data = await addRes.json();

        if (!addRes.ok || data?.status === 422) {
          window.showMessage?.("info", "fa-times", data?.description || "Het gewenste aantal is niet beschikbaar");
          return;
        }

        if (data?.product_title) {
          window.showMessage?.("success", "fa-check", `${data.product_title} wordt aan uw winkelwagen toegevoegd`);
        }
      } catch (err) {
        console.error("Add to cart failed:", err);
        window.showMessage?.("info", "fa-times", "Er ging iets mis bij het toevoegen");
        return;
      }

      // --- 2) UI REFRESH (never show error toast if this fails) ---
      try {
        const res = await fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
        const cart = await res.json();

        if (typeof window.updateCartItemCounts === "function") window.updateCartItemCounts(cart.item_count);

        try {
          if (typeof window.updatePopupWithCartData === "function") window.updatePopupWithCartData(cart);
        } catch (e2) {
          console.warn("updatePopupWithCartData failed:", e2);
        }

        if (typeof window.updateCartDrawer === "function") {
          try {
            await window.updateCartDrawer();
          } catch (e3) {
            console.warn("updateCartDrawer failed:", e3);
          }
        }
      } catch (err) {
        console.warn("Cart refresh failed (item is added):", err);
      }
    });
  });


// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Get cart count and update cart drawer
//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);
//     await updateCartDrawer();
//   });
// });

// Open cart drawer on clicking the cart link
document.addEventListener("DOMContentLoaded", function() {
    const cartIcons = document.querySelectorAll('.cart-icon');
    cartIcons.forEach(cartIcon => {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      })
    })
  
});



// Discount progress bar functionality
document.addEventListener('DOMContentLoaded', function () {
  const progressBar = document.getElementById('discountProgressBar');
  const progressMessage = document.getElementById('discountProgressMessage');

  // Immediately update the progress bar to the stored percentage
  const lastPercentage = localStorage.getItem('lastProgressPercentage') || '0';
  if (progressBar) {
    progressBar.style.width = lastPercentage + '%';
  }

  // Ensure the progress bar and message visibility based on the last stored percentage
  toggleProgressVisibility(lastPercentage);

  // Call updateProgressBar function to fetch the cart and update progress
  updateProgressBar();
});

// Function to update the progress bar and message
function updateProgressBar() {
  const progressBar = document.getElementById('discountProgressBar');
  const progressMessage = document.getElementById('discountProgressMessage');

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      // Adjust this condition based on how you identify free items
      const quantities = cartData.items
        .filter(item => {
          return item.price >= 800 && item.handle !== 'adventskalender';
        })
        .map(item => item.quantity);
      const mainProductCount = quantities.reduce((total, quantity) => total + quantity, 0);

      // Calculate the percentage filled based on the product count (assuming 12 is the max count)
      const percentageFilled = Math.min((mainProductCount / 16) * 100, 100);

      // Update the progress bar width with animation
      progressBar.style.transition = 'width 1s ease';
      progressBar.style.width = `${percentageFilled}%`;

      // Update the message based on the product count
      const message = getMessage(mainProductCount);
      progressMessage.innerHTML = message;

      // Save the current progress percentage in localStorage
      localStorage.setItem('lastProgressPercentage', percentageFilled);

      // Update visibility of the progress bar and message
      toggleProgressVisibility(mainProductCount);
    })
    .catch((error) => console.error('Error updating progress bar:', error));
}

// Function to get the appropriate message based on product count
function getMessage(mainProductCount) {
  const messages = [
    '',
    'Voeg nog 3 producten toe en profiteer van gratis verzending.',
    'Voeg 2 producten toe en profiteer van gratis verzending.',
    'Voeg 1 product toe en profiteer van gratis verzending.',
    'Gratis verzending! Voeg 3 producten toe en profiteer van 10% stapelkorting.',
    'Gratis verzending! Voeg 2 producten toe en profiteer van 10% stapelkorting.',
    'Gratis verzending! Voeg 1 product toe en profiteer van 10% stapelkorting.',
    '10% ontgrendeld! Voeg 3 producten toe en profiteer van 15% stapelkorting.',
    '10% ontgrendeld! Voeg 2 producten toe en profiteer van 20% stapelkorting.',
    '10% ontgrendeld! Voeg 1 product toe en profiteer van 20% stapelkorting.',
    '15% ontgrendeld! Voeg 3 producten toe en profiteer van 20% stapelkorting.',
    '15% ontgrendeld! Voeg 2 producten toe en profiteer van 20% stapelkorting.',
    '15% ontgrendeld! Voeg 1 product toe en profiteer van 20% stapelkorting.',
    '20% ontgrendeld! Voeg 3 producten toe en profiteer van 25% stapelkorting.',
    '20% ontgrendeld! Voeg 2 producten toe en profiteer van 25% stapelkorting.',
    '20% ontgrendeld! Voeg 1 product toe en profiteer van 25% stapelkorting.',
    '25% ontgrendeld! Gefeliciteerd, je hebt de hoogst mogelijke stapelkorting geactiveerd.'
  ];

  // Ensure that if mainProductCount exceeds 12, it stays capped at 12 for message purposes
  return messages[Math.min(mainProductCount, 16)];
}


// messages for small products
  // Function to update the popup with cart data
  
  function updatePopupWithCartData(cartData) {
    const mainProductCount = cartData.items.reduce((total, item) => {
    return item.price >= 800 ? total + item.quantity : total;
    }, 0);


    var title = '';
    var message = '';
    var button = 'Voeg nog 1 item toe';

    switch (mainProductCount) {
      case 1:
        title = 'Gratis Verzending!';
        message = 'Voeg nog 3 items toe en profiteer van Gratis verzending.';
        button = 'Voeg nog 3 items toe';
        break;
      case 4:
        title = 'Gefeliciteerd Gratis Verzending!';
        message = 'Voeg nog 3 items toe en krijg 10% stapelkorting.';
        button = 'Voeg nog 3 artikelen toe';
        break;
      case 7:
        title = 'Gefeliciteerd 10% Korting!';
        message = 'Voeg nog 3 items toe en krijg 15% stapelkorting.';
        button = 'Voeg nog 3 artikelen toe';
        break;
      case 10:
        title = 'Gefeliciteerd 15% Korting!';
        message = 'Voeg nog 3 items toe en krijg 20% stapelkorting.';
        button = 'Voeg nog 3 artikelen toe';
        break;
        case 13:
          title = 'Gefeliciteerd 20% Korting!';
          message = 'Voeg nog 3 items toe en krijg 25% stapelkorting.';
          button = 'Voeg nog 3 artikelen toe.';
          break;
              case 16:
                title = 'Gefeliciteerd 25% Korting!';
                message = 'Gefeliciteerd, je hebt de hoogst mogelijke stapelkorting geactiveerd!';
                button = 'Verder shoppen';
                break;
      default:
        break;
    }

    var popupElement = document.getElementById('popup-batch-discount');
    if (popupElement && message !== '') {
      popupElement.querySelector('.popup__batch--header').textContent = title;
      popupElement.querySelector('.popup__batch--subtitle').textContent = message;
      popupElement.querySelector('.popup__batch--button .btn').textContent = button;
      popupElement.classList.add('active');
    } else {
      popupElement.classList.remove('active');
    }
  }
// handle variant selection UI
document.addEventListener("DOMContentLoaded", function () {
  // Global array to store selected variants
  let selectedVariants = [];

  // Function to handle product variant selection
  function selectVariant(buttonElement) {
    const variantTitle = buttonElement.getAttribute('data-title');
    const variantPrice = buttonElement.getAttribute('data-price');
    const variantImage = buttonElement.getAttribute('data-image');
    const variantId = buttonElement.getAttribute('data-product-variant');
    
    const btnSolo = document.querySelector('#variant-solo');
    const productContainer = buttonElement.closest('.card-body'); // Find the product container
    const card = productContainer.closest('.card');
    const productId = productContainer.getAttribute('data-product-id'); // track variant

    // check if variant already exist
    const existingVariantIndex = selectedVariants.findIndex(
      (variant) => variant.productId === productId
    );
    // Store the selected variant details for this product container
    let selectedVariant = {
      title: variantTitle,
      price: variantPrice,
      imageUrl: variantImage,
      variantId: variantId,
      btnSolo: btnSolo,
      productId: productContainer.getAttribute('data-product-id') // Store the product ID to track variants
    };
    if (existingVariantIndex !== -1) {
      //replace existing variant
      selectedVariants[existingVariantIndex] = selectedVariant;
    } else {
      // Append the selected variant to the global array
      selectedVariants.push(selectedVariant);
    }
    console.log('Selected Variants:', selectedVariants);

    // Display the selected variant in the UI
    displaySelectedVariant(selectedVariant, productContainer);

    // remove red border and give green
    card.classList.add('valid-selection');
    // Close the modal (using Bootstrap's modal close method)
    const modalId = buttonElement.closest('.modal').id; // Get the modal ID dynamically
    $(`#${modalId}`).modal('hide');
  }

// Function to display the selected variant in the UI
function displaySelectedVariant(variant, productContainer) {
    // update image
    const productImage = productContainer.querySelector(`#productImg-${variant.productId}`); // Assuming productImg-{productId} is an ID
    if (productImage) {
        productImage.src = variant.imageUrl;
        productImage.alt = variant.title;
    }

    // update title
    const productTitle = productContainer.querySelector(`#title-${variant.productId}`); // Assuming title-{productId} is an ID
    if (productTitle) {
        productTitle.textContent = variant.title;
    }

    // update price
    const productPrice = productContainer.querySelector(`#price-${variant.productId}`); // Assuming price-{productId} is an ID
    if (productPrice) {
        productPrice.textContent = variant.price;
    }
    const btnSolo = productContainer.querySelector(`#variant-solo-${variant.productId}`);
    if (btnSolo) {
      btnSolo.style.display = 'block';
    }
}



  // Event delegation to handle clicks on dynamically generated buttons
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('select-variant')) {
      selectVariant(event.target); // Call the selectVariant function
    }
  });


// Function to add variant solo to cart
async function handleAddVariantToCart(buttonElement) {
  const productId = buttonElement.getAttribute('data-product-id'); // Get the product ID
  const selectedVariant = selectedVariants.find(variant => variant.productId === productId);


  const variantId = selectedVariant.variantId;

  try {
    // Send AJAX request to add the variant to the cart
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (response.ok) {
      const res = await fetch("/cart.js"); // Fetch updated cart
      const cart = await res.json();

      // Show success message
      const productTitle = selectedVariant.title || 'Product'; // Fallback in case title is missing
      showMessage('success', 'fa-check', `${productTitle} is toegevoegd aan uw winkelwagen.`);

      // Update cart UI
      updatePopupWithCartData(cart);
      updateCartItemCounts(cart.item_count); // Update cart count
      updateCartDrawer(); // Update drawer UI if applicable
    } else {
      showMessage('info', 'fa-times', 'Product toegevoegd aan winkelwagen, maar titel niet gevonden.');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    showMessage('error', 'fa-times', 'Er is een fout opgetreden bij het toevoegen aan de winkelwagen.');
  }
}


// Attach event listeners for "Add to Cart" buttons
document.querySelectorAll('.add-variant-to-cart').forEach(button => {
  button.addEventListener('click', function () {
      handleAddVariantToCart(this);
  });
});

  // Function to add a product variant to the cart
  async function addProductToCart(variantId, quantity = 1) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      });

      if (!response.ok) throw new Error("Failed to add product to cart");
      console.log(`Variant ${variantId} added successfully.`);
    } catch (error) {
      console.error(`Error adding variant ${variantId}:`, error.message);
    }
  }
// add all look to cart
    const addAllToCartBtns = document.querySelectorAll(".add-all-to-cart");
  // Function to collect products with selected variants and add them to cart
async function addAllProductsToCart() {
  const productItems = document.querySelectorAll(".card-body.product-item-select");
  const productVariantIds = [];
  let allVariantsSelected = true; // Flag to check if all variants are selected

  document.querySelector(".spinner").style.display = "flex"; // Show spinner  
  productItems.forEach((item) => {
    let variantId = null;

    // Get the product ID to check for a selected variant
    const productId = item.closest(".card").getAttribute("data-product-id");

    // Check if the product has a selected variant in the global array
    const selectedVariant = selectedVariants.find(
      (variant) => variant.productId === productId
    );


    const card = item.closest('.card');

    // Remove the previous invalid-selection class to restart animation
    card.classList.remove('invalid-selection');

    if (selectedVariant) {
      // If the user has selected a variant, use its ID
      variantId = selectedVariant.variantId;
      card.classList.remove('invalid-selection'); // Ensure no red border if selected
    } else {
      // If the product has variants but none selected
      const variantButton = item.querySelector("button.select-variant");
      if (variantButton) {
        allVariantsSelected = false; // Mark that not all variants are selected
        card.classList.add('invalid-selection'); // Add red border with animation for missing variant
        card.classList.remove('valid-selection');
                // Scroll the card into view
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      //trigger animation
      card.classList.add('animated');
      setTimeout(() => {
        card.classList.remove('animated');
      }, 500);
      }

      // If no variant is selected and it's a solo product, use the default variant ID
      const defaultVariant = item.querySelector("button.add-solo-to-cart");
      if (defaultVariant) {
        variantId = defaultVariant.getAttribute("data-product-variant");
      }
    }

    // Validate and collect the variant ID
    if (variantId) {
      productVariantIds.push(variantId);
    } else {
      console.warn(
        "Product skipped. No variant selected for product with ID:",
        productId
      );
    }
  });

  // Check if all variants are selected before adding to the cart
  if (!allVariantsSelected) {
    showMessage('info', 'fa-times', 'selecteer eerst alle varianten');
    document.querySelector(".spinner").style.display = "none"; // Show spinner
    
    return; // Stop further processing if variants are not selected
  }

  // Add all valid variants to the cart
  if (productVariantIds.length > 0) {
    for (const variantId of productVariantIds) {
      await addProductToCart(variantId);
    }
    showMessage("success", "fa-check", "Alle producten zijn toegevoegd aan uw winkelwagen.");
      document.querySelector(".spinner").style.display = "none"; // Show spinner
    // Get cart count and update cart drawer
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updatePopupWithCartData(cart);
    updateCartItemCounts(cart.item_count); // This updates the cart count label
    await updateCartDrawer();
  } else {
    showMessage('info', 'fa-times', 'failed to process');
  }

}
  // Event listener for "Add All to Cart" buttons
addAllToCartBtns.forEach((btn) => {
  btn.addEventListener("click", function () {
    addAllProductsToCart();
  });
});

});





// Initialize listeners and elements on page load
addCartDrawerListeners();


// end cart slide



  
  // Text fade toggle //
  $.fn.toggleHtml = function(t1, t2){
    if (this.html() == t1) this.html(t2);
    else                   this.html(t1);
    return this;
  };

  
  if ($(window).width() < 1199) {
    var content = $('[data-toggle-text]');
		var contentHeight = content.outerHeight();
    
    if (contentHeight > 250) {
    	content.addClass('faded');
    }
    
    $('.toggle-text').on('click', function(){
    	$(this).closest(content).find('.text').toggleClass('active');
      $(this).toggleHtml(readless+'<i class="fa fa-angle-up"></i>', readmore+'<i class="fa fa-angle-down"></i>');
    });
  }
  
  
	// HEADLNES //
  if ($('.headlines').length > 0) {
    var headlinesAutoplay = $('.headlines').data('autoplay');
    var loopSetting = $('.headlines').data('loop');
    if(loopSetting){
      loopSetting = setLoop($('.headlines').data('items'), 1);
    }
    var pagination = $('.headlines').data('pagination');
    //console.log(pagination);
    $('.headlines').owlCarousel({
      loop: loopSetting,
      margin:0,
      nav:false,
      items:1,
      dots:pagination,
      autoplay:headlinesAutoplay,
      autoplayTimeout:3000,
      touchDrag: loopSetting,
      mouseDrag: loopSetting
    });
  }
  

  
  /* productpage images */
  $('.product-images').owlCarousel({
    loop:false,
    margin:0,
    //nav:true,
    items:1,
    responsive:{
      0: {
        mouseDrag: true,
        touchDrag: true,
        dots: true,
      },
      768: {
        mouseDrag: false,
        touchDrag: false,
        dots: false,
      },
    }
    //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
  }).on('translated.owl.carousel', function(){
  	//console.log('test');
  });
  $('.product-thumbs').owlCarousel({
    loop:false,
    margin:10,
    //nav:true,
    items:5,
    //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
  });
  $('.product-thumbs .image').on('click', function(){
    
  	var imgIndex = $(this).data('index');
    $(this).closest('.product-thumbs').find('.image.active').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.images').find('.product-images').trigger('to.owl.carousel', (imgIndex-1));
    var lastActive = $('.product-thumbs .owl-item.active').last().find('.image');
    if (lastActive.hasClass('active')) {
    	$('.product-thumbs').trigger('next.owl.carousel');	
    }
   var firstActive = $('.product-thumbs .owl-item.active').first().find('.image');
    if (firstActive.hasClass('active')) {
    	$('.product-thumbs').trigger('prev.owl.carousel');	
    }
  });
  
//   /* mobile filters apply */
  $('.apply-filters').on('click', function(e){
  	e.preventDefault();
    $(this).closest('form').submit();
  });
  

  
  // HOME COLLECTIONS //
  var collectionCount = $('.categories-slider .category').length;

  var responsiveBreakpoints = {
    0: 2.5,
    768: 3,
    992: 5
  };

  function shouldLoop() {
    var windowWidth = $(window).width();
    var maxItems = 1;
  
    for (var breakpoint in responsiveBreakpoints) {
      var breakpointNum = parseInt(breakpoint, 10);
      if (windowWidth >= breakpointNum) {
        maxItems = responsiveBreakpoints[breakpoint];
      }
    }
  
    return collectionCount > maxItems;
  }

  $('.categories-slider').owlCarousel({
    loop: shouldLoop(),
    margin: 0,
    autoplay: false,
    autoplayTimeout:2000,
    responsive: {
      0: {
        items: responsiveBreakpoints[0]
      },
      768: {
        items: responsiveBreakpoints[768]
      },
      992: {
        items: responsiveBreakpoints[992]
      }
    }
  });
  // user mouse to make slider work
  //$('.categories-slider').on('mouseover', function() {
  //  $(this).trigger('stop.owl.autoplay');
  //});
  
  //$('.categories-slider').on('mouseleave', function() {
  //  $(this).trigger('play.owl.autoplay', [2000]);
  //});

  // $(window).resize(function() {
  //   $('.categories-slider').trigger('destroy.owl.carousel').owlCarousel({
  //     loop: shouldLoop(),
  //     margin: 0,
  //     autoplay: false,
  //     responsive: {
  //       0: {
  //         items: responsiveBreakpoints[0]
  //       },
  //       768: {
  //         items: responsiveBreakpoints[768]
  //       },
  //       992: {
  //         items: responsiveBreakpoints[992]
  //       }
  //     }
  //   });
  // });

  
//    // HOME CATEGORIES //
//   $('.article-slider').owlCarousel({
//     loop:true,
//     margin:0,
//     autoplay:true,
//     autoplayTimeout:4000,	
//     responsive:{
//         0:{
//             items:2
//         },
//         768:{
//             items:3
//         },
//         992:{
//             items:4
//         }
//     }
// 	});
  
  // MORE IMAGES THUMB CLICK
  $('.products .product .more-images .image').on('click', function(){
  	var product = $(this).closest('.product');
    var image = $(this).data('url');
    $(this).closest('.images').find('.image.active').removeClass('active');
    $(this).addClass('active');
    product.find('.img-wrap img').attr('src', image);
  });
  
  function toggleProductsSlider() {
    var isMobile = $(window).width() < 3500; 
  
    if (isMobile) {
      if ($('.home-products .products-slider').hasClass('owl-loaded')) {
        $('.home-products .products-slider').trigger('destroy.owl.carousel');
      }
      $('.home-products .products-slider').addClass('show__products');
    } else {
      $('.home-products .products-slider').removeClass('show__products');

      if (!$('.home-products .products-slider').hasClass('owl-loaded')) {
        var tiles = $('.home-products .products-slider').data('tiles');
        if (tiles) {
          var tiles = tiles.split('|');
          $('.home-products .products-slider').owlCarousel({
            //loop:true,
            autoplayHoverPause: true,
            margin:0,
            nav:false,
            //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items:1,
            autoplay:true,
            autoplayTimeout:3500,
            responsive:{
                0:{
                    items:tiles[3]
                },
                768:{
                    items:tiles[2]
                },
                992:{
                    items:tiles[1]
                },
                1200: {
                    items:tiles[0]
                }
            }
          });

          $('.home-products .products-slider').on('mouseover', function() {
            $(this).trigger('stop.owl.autoplay');
          });

          $('.home-products .products-slider').on('mouseleave', function() {
            $(this).trigger('play.owl.autoplay', [3500]);
          });

          var productsSlider = $('.products-slider');
          var sliderIndex = 0;
          $.each(productsSlider, function(){
            var cur = $(this);
            sliderIndex++;
            if (sliderIndex != 1) {
              cur.closest('.page').removeClass('active');
            }
          });
        }
      }
    }  
  }
  
  toggleProductsSlider();
  $(window).resize(toggleProductsSlider);
  
  // cart page products
  var tiles = $('#cart-page .products-slider').data('tiles');
  if (tiles) {
    var tiles = tiles.split('|');

    $('#cart-page .products-slider').owlCarousel({
      //loop:true,
      autoplayHoverPause: true,
      margin:0,
      nav:false,
      //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      items:1,
      autoplay:true,
      autoplayTimeout:3500,
      responsive:{
          0:{
              items:tiles[3]
          },
          768:{
              items:tiles[2]
          },
          992:{
              items:tiles[1]
          },
          1200: {
              items:tiles[0],
          }
      }
    });
  }
  
//   // HOME Brands //
  $('.home-brands .brands-slider').owlCarousel({
  	loop: true,
    nav: false,
    autoplay: true,
    responsive: {
    	0: {
      	items: 2,
      },
      425: {
      	items: 3,
      },
      768: {
      	items: 4,
      },
    	992: {
      	items: 5,
      },
      1200: {
      	items: 6,
      },
    }
  });
  
   // TABS //
  $('.tabs-wrap .tabs li a').on('click', function(){
    var index = $(this).data('index');
    $('.tabs-wrap .tabs li.active').removeClass('active');
    $(this).closest('li').addClass('active');
    $('.tabs-wrap .pages .page.active').removeClass('active');
    $('.tabs-wrap .pages .page.page-'+index).addClass('active');
  });

  // scroll to element
 	$('[data-scroll]').on('click', function(){
    var element = $(this).data('scroll');
    var headerHeight = 0;
    if (typeof stickyHeader !== 'undefined' && stickyHeader) {
      headerHeight = $('#header .main-header').outerHeight();
    }
    $('html, body').animate({
      	scrollTop: $(element).offset().top - headerHeight - 30
    }, 500);
  });

 	// MOBILE MENU //
  $(document).on('click', '.open-subs', function(e){
      e.preventDefault();
      var moreCats = $(this).find('.more-cats');
      if (moreCats.length > 0) {
          moreCats.trigger('click');
      }
  });

  $('.mobile-menu .menu ul li .more-cats').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var cur = $(this);
      cur.toggleClass('fa-rotate-90');
      cur.closest('li').find('.subs').first().toggleClass('active');
  });

  
  $('.mobile-menu .subs-back').on('click', function(){
  	$(this).closest('.subs').removeClass('active');
    subsHeight();
  });
  
  /* MOBILE BAR */
  $('.open-mobile-slide').on('click', function(){
    var cur = $(this);
  	var popup = $(this).data('popup');
    if (!cur.hasClass('active')) {
    	$('.mobile-popup.open').removeClass('open');
  	}
    $('.mobile-popup[data-popup="'+popup+'"]').toggleClass('open');
    $('.open-mobile-slide.active').removeClass('active');
    var openPopup = $('.mobile-popup.open').data('popup');
    $('.open-mobile-slide[data-popup="'+openPopup+'"][data-main-link]').addClass('active');
  });
  
  $('.open-mobile-slide[data-popup="search"]:not(.active)').click('click', function(){
    setTimeout(function(){
  		$('[data-popup="search"] input').focus();
    }, 200);
  });
  
  $('.close-popup').on('click', function(){
    var popup = $(this).closest('.mobile-popup').data('popup');
  	$(this).closest('.mobile-popup').removeClass('open');
    $('.open-mobile-slide[data-popup="'+popup+'"]').removeClass('active');
    setTimeout(function(){
    	$('.mobile-menu .subs').removeClass('active');
    }, 200);
  });
  
//   /* usp */
//   $('.usp-slider').owlCarousel({
//     loop:true,
//     margin:0,
//     items:1,
//     autoplay:true
// 	});

  // OPEN FILTERS
  $('.open-filters').on('click', function(){
  	$('.filters-top').slideToggle(200);
  });
  
  // NICE LOOKING SELECTS
  $('.custom-select, #productpage .product-option select, .bundle-option select').dropdown();
  

  // FOOTER TABS
function initMobSlideAccordion(scope) {
  if ($(window).width() < 992) {
    const $scope = $(scope);

    // Check what type of accordion this is
    const isFooter = $scope.find('.footer-title').length > 0;
    const triggerClass = isFooter ? '.footer-title' : '.title';
    const contentClass = isFooter ? '.content-wrap' : '.content-des';

    $scope.find(triggerClass).off('click').on('click', function () {
      const $this = $(this);

      const $allTitles = $scope.find(triggerClass);
      const $allContents = $scope.find(contentClass);

      if (!$this.hasClass('active')) {
        // Close all
        $allTitles.removeClass('active');
        $allContents.removeClass('active').slideUp(300);

        // Open clicked
        $this.addClass('active');
        $this.next(contentClass).addClass('active').slideDown(300);


      } else {
        // Toggle current
        $this.removeClass('active');
        $this.next(contentClass).removeClass('active').slideUp(300);
      }
    });
  }
}

  //call collapse in footer
  initMobSlideAccordion('#footer');
  //call collapse in product page
  initMobSlideAccordion('#product-collapse');
  //call collapse in box contents
  initMobSlideAccordion('#product-collapse-box');
  // SIDEBAR CATS
  $('.menu-box ul li .more-cats, .sidebar ul.side-cats li .more-cats, .sidebar ul.sb-cats-wrap li .more-cats').on('click', function(){
    var cur = $(this);
    if (!(cur.closest('li').hasClass('active'))) {
      cur.closest('ul').find('li').removeClass('active');
      cur.closest('ul').find('li ul').slideUp(300);
      cur.closest('li').addClass('active');
      cur.closest('li').find('>ul').slideDown(300);
    } else {
      cur.closest('li').removeClass('active');
      cur.closest('li').find('>ul').slideUp(300);
    }
    
    $(this).closest('li').find('.mobile-tab').slideToggle();
  });
  
  /* header */
  $('.open-vertical-menu').on('click', function(){
  	$('.vertical-menu-overlay, #header .vertical-menu, .vertical-menu-wrap').toggleClass('active');
  });
  $('.vertical-menu-overlay').on('mouseenter', function(){
  	$('.vertical-menu-overlay, #header .vertical-menu, .vertical-menu-wrap').removeClass('active');
  });
  
  /* input change */
  $('.input-wrap .change a').on('click', function(){
  	var cur = $(this);
    var way = $(this).attr('data-way');
    updateQuantity(way, cur);
  });

  


function updateQuantity(way, cur){
  	var quantity = parseInt(cur.closest('.input-wrap').find('input').val());
  
    if (way == 'up'){
      quantity++;
    } else {
      if (quantity > 1){
          quantity--;
      }
    }
    cur.closest('.input-wrap').find('input').val(quantity);
    if (cur.closest('.input-wrap').hasClass('cart-quantity')) {
      cur.closest('form').submit();
    }
}


function checkLoop(loopItems, maxItems){
  var setLoop = false;
  if(loopItems > maxItems){
    setLoop =  true;
  }
	return setLoop;  
}

function setLoop(loopItems, maxItems){
  if($.isNumeric(maxItems)){
  	return checkLoop(loopItems, maxItems);
  } else {
  	if (maxItems.indexOf('|') != -1) {
    	var splitItems = maxItems.split('|');
      
      if($(window).width() >= 1200){
      	return checkLoop(loopItems, splitItems[0]);
      } else if($(window).width() >= 992){
      	return checkLoop(loopItems, splitItems[1]);
    	} else if($(window).width() >= 768){
      	return checkLoop(loopItems, splitItems[2]);
      } else { 
      	return checkLoop(loopItems, splitItems[3]);
      }
  	}
  }
}




$(document).ready(function() {
  // Function to initialize the carousel
  window.initializeCarousel = function() {
    $('.product-carousel').each(function() {
      var carouselId = '#' + $(this).attr('id');
      if (!$(carouselId).hasClass('owl-loaded')) { // Check if the carousel is not already initialized
        $(carouselId).owlCarousel({
          items: 1,
          dots: true,
          lazyLoad: true,
        });
      }
    });
  }

  // Function to destroy the carousel
  function destroyCarousel() {
    $('.product-carousel').each(function() {
      var carouselId = '#' + $(this).attr('id');
      var owlCarouselData = $(carouselId).data('owl.carousel');
      if (owlCarouselData) {
        owlCarouselData.destroy();
      }
      $(carouselId).removeClass('owl-loaded');
    });
  }

  // Initial check
  if ($(window).width() <= 768) {
    initializeCarousel();
  }

  // Re-initialize carousel on resize
  $(window).on('resize', function() {
    var windowWidth = $(window).width();
    if (windowWidth <= 768) {
      initializeCarousel();
    } else {
      destroyCarousel();
    }
  });
});